import { Typography } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import BoldText from 'components/BoldText';
import useStyles from 'features/Events/components/EventsChart/EventsModal/EventsModalDateTime/EventsModalDateTime.styles';

type EventsModalDateTimeProps = {
  eventTime: number;
};

const EventsModalDateTime = ({ eventTime }: EventsModalDateTimeProps) => {
  const classes = useStyles();

  const date = new Date(eventTime);
  const dateString = date.toISOString().slice(0, 10);
  const time = `${date.getHours()}:${(date.getMinutes() < 10 ? '0' : '') + date.getMinutes()}`;

  return (
    <Typography className={classes.details}>
      Date: <BoldText text={dateString} />{' '}
      <span data-testid="separator" className={classes.separator} /> Time: <BoldText text={time} />{' '}
    </Typography>
  );
};

export default EventsModalDateTime;
